import React from 'react'
import styled from 'styled-components'
import IconControl from './icon-control'
import colours from '../lib/colours'
import '../css/search-widget.css'
import { navigate } from 'gatsby'
import { MobileDeviceWidth } from '../lib/constants'
import { buildSearch } from '../utils/searchUtils'
import IEventedComponent, { messageTypes } from '../components/IEventedComponent'

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  background: ${colours.aqua};
  padding: 35px 0;
`

const StyledSearchContainer = styled.div`
  position: relative;
  display: flex;
  color: ${colours.darkPurple};
  border: 2px solid ${colours.white};
`

const StyledInputPrepend = styled.div`
  align-items: center;
  margin-bottom: 0;
  background: ${colours.white};
  color: ${colours.darkPurple};
  text-align: center;
  display: flex;
  float: left;
  font-size: 30px;
  padding-left: 32px;
  padding-right: 32px;
  border-right: 2px solid ${colours.aqua};
  @media (max-width: ${MobileDeviceWidth}px) {
    padding-left: 20px;
    padding-right: 10px;
    border-right: 0;
    font-size: 1.4em;
  }
`

const StyledInput = styled.div`
  background: ${colours.white};
  color: ${colours.darkPurple};
  display: flex;
  border: 0;
  border-left: 0;
  width: 100% !important;
  height: 100px;
  padding-right: 3px;
  font-size: 36px;
  @media (max-width: ${MobileDeviceWidth}px) {
    height: 76px;
  }
`

const StyledMapButtonContainer = styled.div`
  margin-top: 20px;
`

const StyledFilledButton = styled.button`
  padding: 14px 40px;
  background-color: ${colours.white};
  color: ${colours.darkPurple};
  font-weight: 600;
  border: none;
  border-radius: 0.25rem;
  transition: background-color 0.2s linear;
  &:hover {
    background-color: ${colours.lightGray};
  }
`

interface IProps {}

interface IState {}

const BigSearchControl = class extends IEventedComponent<IProps, IState> {
  componentDidMount() {
    this.initSearch()
  }

  inputRef: any = React.createRef()
  suggestResults: any[] = []

  initSearch = () => {
    const component: any = this
    window.require(['esri/widgets/Search', 'esri/tasks/Locator'], function (Search, Locator) {
      const esriLibrary = {
        Search: Search,
        Locator: Locator
      }
      let searchWidget = buildSearch('largeSearchWidget', esriLibrary)

      searchWidget.on('select-result', (result: any) => {
        const { feature, name } = result.result
        const coords = [feature.geometry.longitude, feature.geometry.latitude]
        navigate('/map/', {
          state: {
            searchTerm: name,
            coords
          }
        })
      })

      searchWidget.when(() => {
        component.inputRef.current.childNodes[0].childNodes[2].childNodes[0].childNodes[0].onkeydown = (event: any) => {
          if (event.keyCode === 13 && component.suggestResults.length > 0) {
            event.preventDefault()
            searchWidget.search(component.suggestResults[0].text)
          }
        }
      })

      searchWidget.on('suggest-start', () => {
        component.suggestResults = []
      })

      // Prevent default when search scroll bar clicked
      searchWidget.on('suggest-complete', (evt: any) => {
        component.suggestResults = evt.results[0].results
        component.inputRef.current.childNodes[0].childNodes[2].childNodes[1].onmousedown = function (event: any) {
          event.preventDefault()
        }
      })
    })
  }

  render() {
    return (
      <StyledWrapper>
        <div className="container">
          <StyledSearchContainer>
            <StyledInputPrepend>
              <IconControl icon="map-marker-alt" />
            </StyledInputPrepend>
            <StyledInput id="largeSearchWidget" ref={this.inputRef} />
          </StyledSearchContainer>
          <StyledMapButtonContainer>
            <StyledFilledButton
              onClick={() => {
                navigate('/map/', { state: { searchTerm: null } })
              }}
            >
              Explore the map
            </StyledFilledButton>
          </StyledMapButtonContainer>
        </div>
      </StyledWrapper>
    )
  }
}

export default BigSearchControl
